/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './status-table.scss';

/*@ngInject*/
export function StatusTableController($sce, $scope, $mdDialog, $filter, statusTableConfiguration, entities, type) {

    var vm = this;

    vm.$onInit = function () {

        vm.statusTableConfiguration = statusTableConfiguration;

        vm.entityType = type;
        vm.columns = vm.statusTableConfiguration.columns;

        vm.statusTableConfiguration.reloadEntities = () => {
            reloadEntities()
        };

        vm.allEntities = [];
        vm.entities = [];

        vm.query = {
            order: "",
            search: null
        };

        vm.cancel = cancel;
        vm.enterFilterMode = enterFilterMode;
        vm.exitFilterMode = exitFilterMode;
        vm.onReorder = onReorder;

        vm.cellStyle = cellStyle;
        vm.cellContent = cellContent;

        vm.loadEntities = vm.statusTableConfiguration.loadEntities;
        vm.reload = reloadEntities;

        reloadEntities();
    };

    $scope.$watch("vm.query.search", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateEntities();
        }
    });

    function enterFilterMode() {
        vm.query.search = '';
    }

    function exitFilterMode() {
        vm.query.search = null;
        updateEntities();
    }

    function onReorder() {
        updateEntities();
    }

    function reloadEntities() {
        vm.loading = true;
        vm.allEntities = [];
        vm.statusTableConfiguration.loadEntities(entities).then(
            function success(data) {
                vm.allEntities = data;
                updateEntities();
                vm.loading = false;
            },
            function fail() { }
        )
    }

    function updateEntities() {
        var result = $filter('orderBy')(vm.allEntities, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, { $: vm.query.search });
        }
        vm.entities = result;
    }

    function cellStyle(entity, column) {
        var style;
        var value = entity[column.key];
        if (column.cellStyleFunction) {
            try {
                style = column.cellStyleFunction(value, entity, $filter);
            } catch (e) {
                //
            }
        }
        return style || {};
    }

    function cellContent(entity, column) {
        var content;
        var value = entity[column.key];
        if (column.cellContentFunction) {
            var strContent = '';
            if (angular.isDefined(value)) {
                strContent = '' + value;
            }
            content = strContent;
            try {
                content = column.cellContentFunction(value, entity, $filter);
            } catch (e) {
                content = strContent;
            }
        } else {
            content = defaultContent(column, value);
        }
        return content;
    }

    function defaultContent(column, value) {
        if (angular.isDefined(value)) {
            var columnField = column;
            if (columnField.time) {
                return $filter('date')(value, 'yyyy-MM-dd HH:mm:ss');
            } else if (columnField.boolean) {
                var checkboxClass = value ? 'md-checked' : '';
                return $sce.trustAsHtml(`<md-checkbox class="${checkboxClass}" disabled><div class="md-icon"></div></md-checkbox>`);
            } else {
                return value;
            }
        } else {
            return '';
        }
    }

    function cancel() {
        $mdDialog.cancel();
    }
}


// WEBPACK FOOTER //
// ./src/app/status-table/status-table.controller.js